var _g, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVoiceRxDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1538_11480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#7742FE"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1538_11480)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 3,
    width: 32,
    height: 32,
    rx: 10,
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1538_11480)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_1538_11480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.74 14.3302L23.3 9.33018C23.2065 9.22659 23.0924 9.14371 22.9649 9.08688C22.8375 9.03004 22.6995 9.00051 22.56 9.00018H14.56C14.2277 8.99622 13.898 9.05774 13.5895 9.18124C13.281 9.30473 12.9999 9.48778 12.7622 9.71993C12.5245 9.95208 12.3348 10.2288 12.204 10.5342C12.0732 10.8397 12.0039 11.1679 12 11.5002V26.5002C12.0039 26.8324 12.0732 27.1607 12.204 27.4661C12.3348 27.7716 12.5245 28.0483 12.7622 28.2804C12.9999 28.5126 13.281 28.6956 13.5895 28.8191C13.898 28.9426 14.2277 29.0041 14.56 29.0002H25.44C25.7723 29.0041 26.102 28.9426 26.4105 28.8191C26.719 28.6956 27.0001 28.5126 27.2378 28.2804C27.4755 28.0483 27.6652 27.7716 27.796 27.4661C27.9268 27.1607 27.9961 26.8324 28 26.5002V15.0002C27.9994 14.7523 27.9067 14.5136 27.74 14.3302Z",
    fill: "#7742FE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0536 13.7932C24.1836 13.9545 24.3717 14.0582 24.5775 14.0821L27.607 14.135L23.9374 10.0704L23.8824 13.2199C23.8621 13.426 23.9235 13.6319 24.0536 13.7932Z",
    fill: "#BBA0FF"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_1538_11480)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_1538_11480)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.75 19V16C17.75 15.4033 17.9871 14.831 18.409 14.409C18.831 13.9871 19.4033 13.75 20 13.75C20.5967 13.75 21.169 13.9871 21.591 14.409C22.0129 14.831 22.25 15.4033 22.25 16V19C22.25 19.5967 22.0129 20.169 21.591 20.591C21.169 21.0129 20.5967 21.25 20 21.25C19.4033 21.25 18.831 21.0129 18.409 20.591C17.9871 20.169 17.75 19.5967 17.75 19ZM23.75 19C23.75 18.9005 23.7105 18.8052 23.6402 18.7348C23.5698 18.6645 23.4745 18.625 23.375 18.625C23.2755 18.625 23.1802 18.6645 23.1098 18.7348C23.0395 18.8052 23 18.9005 23 19C23 19.7956 22.6839 20.5587 22.1213 21.1213C21.5587 21.6839 20.7956 22 20 22C19.2044 22 18.4413 21.6839 17.8787 21.1213C17.3161 20.5587 17 19.7956 17 19C17 18.9005 16.9605 18.8052 16.8902 18.7348C16.8198 18.6645 16.7245 18.625 16.625 18.625C16.5255 18.625 16.4302 18.6645 16.3598 18.7348C16.2895 18.8052 16.25 18.9005 16.25 19C16.2511 19.9293 16.5968 20.8252 17.2202 21.5144C17.8436 22.2036 18.7005 22.6372 19.625 22.7313V24.25C19.625 24.3495 19.6645 24.4448 19.7348 24.5152C19.8052 24.5855 19.9005 24.625 20 24.625C20.0995 24.625 20.1948 24.5855 20.2652 24.5152C20.3355 24.4448 20.375 24.3495 20.375 24.25V22.7313C21.2995 22.6372 22.1564 22.2036 22.7798 21.5144C23.4032 20.8252 23.7489 19.9293 23.75 19Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1538_11480",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289653 0 0 0 0 0.179688 0 0 0 0 0.375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1538_11480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1538_11480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1538_11480",
    x: 0,
    y: 0,
    width: 42,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289653 0 0 0 0 0.179688 0 0 0 0 0.375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1538_11480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1538_11480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1538_11480",
    x: 6,
    y: 5.5,
    width: 29,
    height: 29,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.5,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.289653 0 0 0 0 0.179688 0 0 0 0 0.375 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1538_11480"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1538_11480",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1538_11480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_1538_11480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 20.0004,
    fill: "white",
    transform: "translate(12 9)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_1538_11480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(14 13)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoiceRxDefault);
export default __webpack_public_path__ + "static/media/voice-rx-default.caf306903024cbca801f320ba4de2156.svg";
export { ForwardRef as ReactComponent };